import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalComponent } from '../../../shared-components/modal/modal.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit, OnDestroy {
  alive = true;
  ampResetPwdUrl = '';
  allianceResetPwdUrl = '';

  @ViewChild('forgotPwdSelection') forgotPwdSelection: ModalComponent;
  constructor(private accountSvc: AccountService,
  private router: Router) { }

  ngOnInit() {
    this.forgotPwdSelection.show();
  }

  async ngAfterViewInit() {
    const lsUrls = await this.accountSvc.getForgotPwdUrls();
    console.log(lsUrls);
    this.ampResetPwdUrl = lsUrls[0];
    this.allianceResetPwdUrl = lsUrls[1];
  }

  redirectToAMP() {
    this.forgotPwdSelection.hide();
    window.open(this.ampResetPwdUrl, '_self');
  }

  redirectToAlliance() {
    this.forgotPwdSelection.hide();
    window.open(this.allianceResetPwdUrl, '_self');
  }

  redirectToMyJSSI() {
    this.forgotPwdSelection.hide();
    this.router.navigate(['/pages/reset-password']);
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/account/forgot-password/forgot-password.component.ts